import React, { useState, useEffect } from 'react';
import './EventModal.css';

const EventModal = ({ event, onClose, onSave, onDelete, currentUser, members = [] }) => {
  const [title, setTitle] = useState(event.title);
  const [start, setStart] = useState(event.start);
  const [end, setEnd] = useState(event.end);
  const [type, setType] = useState(event.type || 'band_event');
  const [memberEmail, setMemberEmail] = useState(
    event.memberEmail || (currentUser ? currentUser.email : '')
  );

  useEffect(() => {
    setTitle(event.title);
    setStart(event.start);
    setEnd(event.end);
    setType(event.type || 'band_event');
    setMemberEmail(event.memberEmail || (currentUser ? currentUser.email : ''));

    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [event, onClose]);

  // Helper to format Date objects for datetime-local input
  const formatDateTimeLocal = (date) => {
    if (!date) return '';
    const dt = new Date(date);
    dt.setMinutes(dt.getMinutes() - dt.getTimezoneOffset());
    return dt.toISOString().slice(0, 16);
  };

  const handleSave = () => {
    const typeLabel = type === 'vacation' ? 'Holiday' : type === 'practice' ? 'Practice' : 'Gig';
    const savedTitle = title && title.trim() ? title.trim() : typeLabel;

    let savedStart = new Date(start);
    let savedEnd = new Date(end);

    // Apply type-based time defaults for new events when start === end (times untouched)
    if (!event.id && savedStart.getTime() === savedEnd.getTime()) {
      if (type === 'vacation') {
        savedStart = new Date(savedStart.getFullYear(), savedStart.getMonth(), savedStart.getDate(), 0, 0, 0);
        savedEnd   = new Date(savedStart.getFullYear(), savedStart.getMonth(), savedStart.getDate(), 23, 59, 59);
      } else {
        savedStart = new Date(savedStart.getFullYear(), savedStart.getMonth(), savedStart.getDate(), 19, 0, 0);
        savedEnd   = new Date(savedStart.getFullYear(), savedStart.getMonth(), savedStart.getDate(), 23, 0, 0);
      }
    }

    onSave({
      ...event,
      title: savedTitle,
      start: savedStart,
      end: savedEnd,
      type,
      ...(type === 'vacation' ? { memberEmail } : {}),
    });
  };

  const handleDelete = () => {
    if (window.confirm(`Are you sure you want to delete "${event.title}"?`)) {
      onDelete(event.id);
    }
  };

  const isCreator = currentUser && currentUser.email === event.createdBy;
  const isAdmin = currentUser && currentUser.isAdmin;

  return (
    <div className="event-modal-overlay">
      <div className="event-modal dark">
        <div className="event-modal-header">
          <h2>{event.id ? 'Event Details' : 'Add New Event'}</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <p><strong>Title:</strong>
          {(isCreator || isAdmin) ? (
            <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} />
          ) : (
            <span> {event.title}</span>
          )}
        </p>
        <p><strong>Start:</strong>
          {(isCreator || isAdmin) ? (
            <input type="datetime-local" value={formatDateTimeLocal(start)} onChange={(e) => setStart(e.target.value)} />
          ) : (
            <span> {new Date(start).toLocaleString()}</span>
          )}
        </p>
        <p><strong>End:</strong>
          {(isCreator || isAdmin) ? (
            <input type="datetime-local" value={formatDateTimeLocal(end)} onChange={(e) => setEnd(e.target.value)} />
          ) : (
            <span> {new Date(end).toLocaleString()}</span>
          )}
        </p>
        <p>
          <label htmlFor="event-type"><strong>Event Type:</strong></label>
          {(isCreator || isAdmin || !event.id) ? (
            <select id="event-type" value={type} onChange={e => setType(e.target.value)}>
              <option value="band_event">Gig</option>
              <option value="practice">Practice</option>
              <option value="vacation">Holiday</option>
            </select>
          ) : (
            <span> {type === 'vacation' ? 'Holiday' : type === 'practice' ? 'Practice' : 'Gig'}</span>
          )}
        </p>
        {type === 'vacation' && (
          <p>
            <label htmlFor="member-email"><strong>Member:</strong></label>
            {(isCreator || isAdmin || !event.id) ? (
              <select id="member-email" value={memberEmail} onChange={e => setMemberEmail(e.target.value)}>
                {(members || []).map(m => (
                  <option key={m.email} value={m.email}>{m.email}</option>
                ))}
              </select>
            ) : (
              <span> {memberEmail}</span>
            )}
          </p>
        )}
        <div className="event-actions">
          {(isCreator || isAdmin) && <button onClick={handleSave}>Save</button>}
          {(isCreator || isAdmin) && event.id && <button onClick={handleDelete} className="delete-button">Delete</button>}
          <button onClick={onClose} className="cancel-button">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default EventModal;
